import {Column} from 'react-table'
import {User} from '../../../../../../../interfaces/user'
import {StringCell} from '../../../../../../../helpers/elements/custom/CustomTable/StringCell'
import {UserActionsCell} from './UserActionsCell'
import { UserStatusCell } from './UserStatusCell'

const userColumns: ReadonlyArray<Column<User>> = [
  {
    Header: 'Nombre',
    accessor: 'name',
    Cell: ({...props}) => <StringCell value={props.data[props.row.index].name}></StringCell>,
  },
  {
    Header: 'Correo electrónico',
    accessor: 'emailAddress',
    Cell: ({...props}) => (
      <StringCell className='' value={props.data[props.row.index].emailAddress}></StringCell>
    ),
  },
  {
    Header: 'Teléfono',
    accessor: 'contactPhoneNumber',
    Cell: ({...props}) => (
      <StringCell value={props.data[props.row.index].contactPhoneNumber}></StringCell>
    ),
  },
  {
    Header: 'Rol',
    accessor: 'type',
    Cell: ({...props}) => <StringCell value={props.data[props.row.index].formattedType}></StringCell>,
  },
  {
    Header: 'Estado',
    accessor: 'status',
    Cell: ({...props}) => <UserStatusCell user={props.data[props.row.index]} />,
  },
  {
    Header: 'Acciones',
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell user={props.data[props.row.index]} />,
  },
]

export {userColumns}
